import { render } from "./SidebarNav.vue?vue&type=template&id=6c5cc84c&scoped=true"
import script from "./SidebarNav.vue?vue&type=script&lang=js"
export * from "./SidebarNav.vue?vue&type=script&lang=js"

import "./SidebarNav.vue?vue&type=style&index=0&id=6c5cc84c&scoped=true&lang=css"

import exportComponent from "/Users/nick/Desktop/self-gens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5cc84c"]])

export default __exports__